module.exports = __webpack_public_path__ + "static/img/miamasuo.4fc56a08.png";